( function ( _s ) {
	_s.fn.learnDashEditProfileForm = function () {
		return this.each( el => {
			const _self = _s( el );
			const _form = _self.find( 'form' );
		} );
	};

	_s( document ).ready( () => {
		_s( '.learndash-edit-profile-form' ).learnDashEditProfileForm();
	} );
} )( window._s );
